import {
  bodyB,
  bodyCompact,
  bodyLong,
  bodyM,
  captionM,
  captionSb,
  heroTitle,
  largeTitle,
  subTitle1,
  subTitle2,
  subTitle3,
  tag1M,
  tag1Sb,
  tag2,
  title1,
  title2
} from "./chunk-XSE47NEN.mjs";
import "./chunk-UOJNIETM.mjs";
export {
  bodyB,
  bodyCompact,
  bodyLong,
  bodyM,
  captionM,
  captionSb,
  heroTitle,
  largeTitle,
  subTitle1,
  subTitle2,
  subTitle3,
  tag1M,
  tag1Sb,
  tag2,
  title1,
  title2
};
